export function offlineQualifier(description: string): string {
  if (!navigator.onLine)
    return `${description} — will sync when you reconnect`;
  return description;
}

/**
 * Wraps mutateAsync for offline-safe usage.
 *
 * When online: calls mutateAsync() and returns the result (normal behavior).
 * When offline: calls mutate() (fire-and-forget, onMutate fires for optimistic
 * update, mutation queues for later) and returns undefined immediately so the
 * caller's post-mutation UI code (close dialog, show toast) runs without blocking.
 */
export async function offlineMutate<TData, TVariables>(
  mutation: {
    mutate: (vars: TVariables) => void;
    mutateAsync: (vars: TVariables) => Promise<TData>;
  },
  variables: TVariables,
): Promise<TData | undefined> {
  if (!navigator.onLine) {
    mutation.mutate(variables);
    return undefined;
  }
  return mutation.mutateAsync(variables);
}
